import React, { Component } from "react";
import {connect} from "react-redux";
import { replace } from "connected-react-router";
import PropTypes from "prop-types";
import { Input, Select, DatePicker, Icon, Layout, Button, message } from "antd";
import "antd/dist/antd.css";
import "./style.scss";
import ClickShare from "../../../../../common/components/ClickShare/ClickShare"
import moment from "moment";
import {uploadTypeConfigs, UPLOAD_TYPE_ALL} from "../../../../../consts/uploadtypes";

const { Option } = Select;
const { RangePicker } = DatePicker;
const { Header } = Layout;

// 与 native-list / web-list 进入页面时的默认筛选条件保持一致：近 7 天、其余为空、全部平台
export function getDefaultFilterConditions(type) {
  const dateRange = {
    beginTime: moment().startOf("day").subtract(6, "days").valueOf(),
    endTime: moment().startOf("day").valueOf()
  };
  if (type === "native") {
    return {
      deviceId: "",
      appId: "",
      appVersion: "",
      diagnosisId: "",
      descriptionKeyword: "",
      uploadType: UPLOAD_TYPE_ALL,
      platform: 0,
      ...dateRange
    };
  }
  return {
    deviceId: "",
    ...dateRange
  };
}

class HeaderBar extends Component {

  static propTypes = {
    filterConditions: PropTypes.object,
    updateFilterConditions: PropTypes.func,
    fetchTasks: PropTypes.func,
    fetchInitData: PropTypes.func,
    type: PropTypes.string
  };

  static defaultProps = {
    filterConditions: {
      deviceId: "",
      appId: "",
      appVersion: "",
      diagnosisId: "",
      descriptionKeyword: "",
      uploadType: UPLOAD_TYPE_ALL,
      platform: 0,
      beginTime: moment().startOf("week"),
      endTime: moment().startOf("day")
    },
    updateFilterConditions: null,
    fetchTasks: null,
    fetchInitData: null
  };

  render() {
    const { filterConditions, type } = this.props;
    return (
      <Header className="header">
        <div className="tasklist-filterbar-container">
          <Input.Group compact className="filterbar-group">
            {
              type === "native" &&
              <Select
                data-test="platform-selector"
                value={filterConditions.platform}
                onChange={this.handlePlatformChange}
                style={{ minWidth: "100px" }}
              >
                <Option value={0}>全部平台</Option>
                <Option value={1}>Android</Option>
                <Option value={2}>iOS</Option>
                <Option value={3}>Device</Option>
                <Option value={4}>Web</Option>
              </Select>
            }
            {
              type === "native" &&
              <Select
                data-test="uploadType-selector"
                value={filterConditions.uploadType === void 0 ? UPLOAD_TYPE_ALL : filterConditions.uploadType}
                onChange={this.handleUploadTypeChange}
                style={{ minWidth: "120px" }}
              >
                <Option value={UPLOAD_TYPE_ALL}>全部上传方式</Option>
                {uploadTypeConfigs.map(item => (
                  <Option key={item.uploadType} value={item.uploadType}>{item.uploadTypeName}上传</Option>
                ))}
              </Select>
            }
            <RangePicker
              data-test="range-picker"
              allowClear={false}
              format="YYYY-MM-DD"
              placeholder={["起始时间", "结束时间"]}
              onChange={this.handleTimeRangeChange}
              value={[moment(filterConditions.beginTime), moment(filterConditions.endTime)]}
              style={{ minWidth: "240px" }}
            />
            <Input
              data-test="deviceId-input"
              className="filter-input device-filter-input"
              placeholder={type === "native" ? "设备序列号" : "设备编号"}
              value={filterConditions.deviceId}
              onChange={this.handleDeviceIdChange}
              suffix={
                filterConditions.deviceId ? (
                  <Icon
                    data-test="clean-deviceId-icon"
                    className="empty-search"
                    key="empty-search"
                    type="close-circle"
                    onClick={this.handleCleanDeviceId}
                  />
                ) : (
                  <span />
                )
              }
            />
            {
              type === "native" &&
              <Input
                data-test="appId-input"
                className="filter-input short-filter-input"
                placeholder="AppId"
                value={filterConditions.appId}
                onChange={this.handleAppIdChange}
                suffix={
                  filterConditions.appId ? (
                    <Icon
                      data-test="clean-appId-icon"
                      className="empty-search"
                      key="empty-search"
                      type="close-circle"
                      onClick={this.handleCleanAppId}
                    />
                  ) : (
                    <span />
                  )
                }
              />
            }
            {
              type === "native" &&
              <Input
                data-test="appVersion-input"
                className="filter-input short-filter-input"
                placeholder="AppVersion"
                value={filterConditions.appVersion}
                onChange={this.handleAppVersionChange}
                suffix={
                  filterConditions.appVersion ? (
                    <Icon
                      data-test="clean-appVersion-icon"
                      className="empty-search"
                      key="empty-search"
                      type="close-circle"
                      onClick={this.handleCleanAppVersion}
                    />
                  ) : (
                    <span />
                  )
                }
              />
            }
            {
              type === "native" &&
              <Input
                data-test="diagnosisId-input"
                className="filter-input short-filter-input"
                placeholder="诊断ID"
                value={filterConditions.diagnosisId}
                onChange={this.handleDiagnosisIdChange}
                suffix={
                  filterConditions.diagnosisId ? (
                    <Icon
                      data-test="clean-diagnosisId-icon"
                      className="empty-search"
                      key="empty-search"
                      type="close-circle"
                      onClick={this.handleCleanDiagnosisId}
                    />
                  ) : (
                    <span />
                  )
                }
              />
            }
            {
              type === "native" &&
              <Input
                data-test="descriptionKeyword-input"
                className="filter-input short-filter-input"
                placeholder="描述关键词"
                title="在上报的用户描述里搜索"
                value={filterConditions.descriptionKeyword}
                onChange={this.handleDescriptionKeywordChange}
                onPressEnter={this.handleSearch}
                suffix={
                  filterConditions.descriptionKeyword ? (
                    <Icon
                      className="empty-search"
                      key="empty-search"
                      type="close-circle"
                      onClick={this.handleCleanDescriptionKeyword}
                    />
                  ) : (
                    <span />
                  )
                }
              />
            }
          </Input.Group>
          <Button data-test="search-button" icon="search" type="primary" onClick={this.handleSearch}>
            搜索
          </Button>
          <Button data-test="reset-button" icon="reload" className="reset-button" onClick={this.handleReset}>
            重置
          </Button>
        </div>
        <ClickShare buttonId={"share-button"} shareUrl={this.composeShareUrl()} buttonText={"分享"} />
      </Header>
    );
  }

  composeShareUrl = () => {
    const {filterConditions, type, pathname} = this.props;
    if (type === "native") {
      const uploadType = filterConditions.uploadType === void 0 || filterConditions.uploadType === null ? "" : filterConditions.uploadType;
      return `${window.location.origin}/#${pathname}?deviceId=${filterConditions.deviceId}&appId=${filterConditions.appId || ""}&appVersion=${filterConditions.appVersion || ""}&diagnosisId=${filterConditions.diagnosisId || ""}&descriptionKeyword=${encodeURIComponent(filterConditions.descriptionKeyword || "")}&uploadType=${uploadType}&beginTime=${moment(filterConditions.beginTime).valueOf()}&endTime=${moment(filterConditions.endTime).valueOf()}&platform=${filterConditions.platform}`
    } else {
      return `${window.location.origin}/#${pathname}?deviceId=${filterConditions.deviceId}&beginTime=${moment(filterConditions.beginTime).valueOf()}&endTime=${moment(filterConditions.endTime).valueOf()}`
    }
  };

  // event handlers
  handleSearch = () => {
    const { filterConditions, fetchTasks, type } = this.props;
    if (type !== "native" && filterConditions.deviceId === "") {
      message.error("必须填写设备编号才能进行查询！");
      return;
    }
    if (type === "native") {
      fetchTasks({
        deviceId: filterConditions.deviceId,
        appId: filterConditions.appId,
        appVersion: filterConditions.appVersion,
        diagnosisId: filterConditions.diagnosisId,
        descriptionKeyword: filterConditions.descriptionKeyword,
        uploadType: filterConditions.uploadType,
        platform: filterConditions.platform,
        beginTime: moment(filterConditions.beginTime).valueOf(),
        endTime: moment(filterConditions.endTime).valueOf()
      });
    } else {
      fetchTasks({
        deviceId: filterConditions.deviceId,
        beginTime: moment(filterConditions.beginTime).valueOf(),
        endTime: moment(filterConditions.endTime).valueOf()
      })
    }

  };

  handleReset = () => {
    const { updateFilterConditions, fetchInitData, type, pathname, search, dispatch } = this.props;

    updateFilterConditions(getDefaultFilterConditions(type));
    // 分享链接进入时 url 带有筛选参数，重置后一并清掉，避免刷新页面又回到旧条件
    if (search) {
      dispatch(replace(pathname));
    }
    // 与首次进入页面一致：拉取最新日志列表
    if (fetchInitData) {
      fetchInitData();
    }
  };

  handleDeviceIdChange = e => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      deviceId: e.target.value
    });
  };

  handleCleanDeviceId = () => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      deviceId: ""
    });
  };

  handleAppIdChange = e => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      appId: e.target.value
    });
  };

  handleCleanAppId = () => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      appId: ""
    });
  };

  handleAppVersionChange = e => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      appVersion: e.target.value
    });
  };

  handleCleanAppVersion = () => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      appVersion: ""
    });
  };

  handleDiagnosisIdChange = e => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      diagnosisId: e.target.value
    });
  };

  handleDescriptionKeywordChange = e => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      descriptionKeyword: e.target.value
    });
  };

  handleCleanDescriptionKeyword = () => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      descriptionKeyword: ""
    });
  };

  handleCleanDiagnosisId = () => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      diagnosisId: ""
    });
  };

  handleUploadTypeChange = value => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      uploadType: value
    });
  };

  handlePlatformChange = value => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      platform: value
    });
  };

  handleTimeRangeChange = value => {
    const { filterConditions, updateFilterConditions } = this.props;
    const [beginMoment, endMoment] = value;

    if (endMoment.diff(beginMoment) >= 7 * 86400000) {
      message.warn("请保证选择的时间范围不超过7天");
      return;
    }
    updateFilterConditions({
      ...filterConditions,
      beginTime: beginMoment.valueOf(),
      endTime: endMoment.valueOf()
    });

  };
}

function mapStateToProps(state) {
  return {
    pathname: state.router.location.pathname,
    search: state.router.location.search,
    hash: state.router.location.hash,
  }
}

export default connect(mapStateToProps)(HeaderBar);
